import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function SitePublisherMenu({ activeItem = null }) {
  return (
    <>
      <li className="nav-item">
        <Link
          to="/publishers/all"
          className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "all-site-publisher"
                      )} `}
        >
          <i className="nav-icon hl-view-circle"></i>
          <p> نماش دهنده ها</p>
        </Link>
      </li>
    </>
  );
}

export default SitePublisherMenu;
